<template>
  <div id="AboutUs">
    <!-- 公司横幅 -->
    <div class="company-banner">
      <div class="banner-content">
        <h1 data-i18n="home_about">关于我们</h1>
        <p data-i18n="home_aboutus">创新 · 专业 · 值得信赖</p>
      </div>
    </div>

    <!-- 主要内容 -->
    <div
      class="container about-container"
      v-for="(item, index) in aboutPage"
      :key="index"
    >
      <!-- 公司概况 -->
      <section class="about-section wow slideInUp">
        <h2 class="section-title">{{ item.title[lang] }}</h2>
        <div class="section-content">
          <div
            class="product-content rich-text-content ql-editor"
            v-html="item.introduce[lang]"
          ></div>
        </div>
      </section>

      <!-- 轮播图 -->
      <section class="about-section carousel-section wow slideInUp">
        <h2 class="section-title" data-i18n="aboutUs">企业荣誉与风采</h2>

        <!-- 上层：著作权/专利轮播 -->
        <div class="double-carousel">
          <div
            class="upper-carousel"
            v-for="(item, index) in OneSwiper"
            :key="'cert-' + index"
          >
            <h2>{{ item.title[lang] }}</h2>
            <el-carousel
              :interval="4000"
              type="card"
              arrow="always"
              height="500px"
              class="certificate-carousel"
            >
              <el-carousel-item
                v-for="(item, index) in item.content"
                :key="'cert-' + index"
              >
                <div class="certificate-item">
                  <img
                    :src="item"
                    :alt="'证书' + index"
                    class="certificate-image"
                  />
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <!-- 下层：原有图文轮播 -->
          <div
            class="lower-carousel"
            v-for="(item, index) in TwoSwiper"
            :key="'cert-' + index"
          >
            <h2>{{item.title[lang]}}</h2>
            <el-carousel
              :interval="5000"
              type="card"
              arrow="always"
              height="500px"
              class="custom-carousel"
            >
              <el-carousel-item
              v-for="(item, index) in item.content"
                :key="'cert-' + index"
              >
                <div class="carousel-card">
                  <img
                    :src="item.image"
                    :alt="item.describe"
                    class="carousel-image"
                  />
                  <div class="carousel-content">
                    <h3>产品证书</h3>
                    <p>{{ item.describe[lang] }}</p>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </section>

      <!-- 发展历程 -->
      <!-- <section class="about-section timeline-section wow slideInUp">
        <h2 class="section-title">发展历程</h2>
        <div class="timeline">
          <div
            v-for="(item, index) in milestones"
            :key="index"
            class="timeline-item"
          >
            <div class="timeline-year">{{ item.year }}</div>
            <div class="timeline-dot"></div>
            <div class="timeline-content">
              <h3>{{ item.title }}</h3>
              <p>{{ item.description }}</p>
            </div>
          </div>
        </div>
      </section> -->

      <!-- 企业文化 -->
      <!-- <section class="about-section culture-section wow slideInUp">
        <h2 class="section-title">企业文化</h2>
        <div class="culture-grid">
          <div
            v-for="(item, index) in cultureItems"
            :key="index"
            class="culture-item"
          >
            <div class="culture-icon">
              <i :class="item.icon"></i>
            </div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
          </div>
        </div>
      </section> -->

      <!-- 团队展示 -->
      <!-- <section class="about-section team-section wow slideInUp">
        <h2 class="section-title">核心团队</h2>
        <div class="team-grid">
          <div
            v-for="(member, index) in teamMembers"
            :key="index"
            class="team-member"
          >
            <img
              :src="member.avatar"
              :alt="member.name"
              class="member-avatar"
            />
            <div class="member-info">
              <h3>{{ member.name }}</h3>
              <p class="position">{{ member.position }}</p>
              <p class="bio">{{ member.bio }}</p>
            </div>
          </div>
        </div>
      </section> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { WOW } from "wowjs";
import { websiteUrl, fileUrl } from "../../url.js"; //全局配置URL ip
// 引入翻译变量
import { sharedState } from "../assets/js/languages/fanyi";
import { translatePage } from "../assets/js/languages/change_language";
export default {
  name: "AboutUs",
  data() {
    return {
      aboutPage: [],
      aboutSwiper: [],
      milestones: [
        {
          year: "2015",
          title: "公司成立",
          description: "在[山东省济南市]正式注册成立，开始提供基础服务",
        },
        {
          year: "2017",
          title: "获得首轮融资",
          description: "获得[投资机构]的A轮融资，金额达[金额]",
        },
        {
          year: "2019",
          title: "产品升级",
          description: "推出革命性的[产品名称]，市场反响热烈",
        },
        {
          year: "2021",
          title: "国际化布局",
          description: "在[国家]设立首个海外办事处",
        },
        {
          year: "2023",
          title: "行业领先",
          description: "市场份额达到[比例]，成为行业标杆企业",
        },
      ],
      cultureItems: [
        {
          icon: "el-icon-aim",
          title: "使命",
          description: "用科技创造价值，让世界更智能",
        },
        {
          icon: "el-icon-view",
          title: "愿景",
          description: "成为全球领先的[行业]解决方案提供商",
        },
        {
          icon: "el-icon-connection",
          title: "价值观",
          description: "客户至上、创新驱动、诚信为本",
        },
        {
          icon: "el-icon-office-building",
          title: "工作氛围",
          description: "开放包容、协作共赢、学习成长",
        },
      ],
      teamMembers: [
        {
          name: "张明",
          position: "创始人兼CEO",
          bio: "[行业]领域专家，拥有[年数]年从业经验，曾任职于[知名公司]",
          avatar: require("@/assets/img/qq.png"),
        },
        {
          name: "李华",
          position: "技术总监",
          bio: "资深技术专家，主导开发了[产品名称]等核心产品",
          avatar: require("@/assets/img/qq.png"),
        },
        {
          name: "王芳",
          position: "市场总监",
          bio: "品牌营销专家，成功打造了多个行业知名品牌",
          avatar: require("@/assets/img/qq.png"),
        },
      ],

    };
  },
  created() {
    this.getAboutus(); // 获取页面数据
    this.getSwiper(); // 获取荣誉数据
  },
  // 语言变量 计算属性
  computed: {
    lang() {
      return sharedState.lang;
    },
    OneSwiper() {
      //  aboutSwiper过滤出特定 type
      return this.aboutSwiper.filter((item) => item.type === "1");
    },
    TwoSwiper() {
      //  aboutSwiper过滤出特定 type
      return this.aboutSwiper.filter((item) => item.type === "2");
    },
  },
  mounted() {
    var wow = new WOW();
    wow.init();
    translatePage();
  },
  methods: {
    //获取页面内容-产品中心
    async getAboutus() {
      const cache = localStorage.getItem("aboutUs");
      if (cache) {
        this.aboutPage = JSON.parse(cache);
      }
      try {
        const response = await axios.get(
          `${websiteUrl}/mes-official-website-manage/aboutUs/list`
        );
        const data = response.data.rows;
        data.forEach((item) => {
          if (typeof item.imageContent === "string") {
            item.imageContent = JSON.parse(item.imageContent);
            if (Array.isArray(item.imageContent)) {
              item.imageContent.forEach((imageObj) => {
                if (imageObj.image) {
                  imageObj.image = fileUrl + imageObj.image;
                }
              });
            }
            item.introduce = JSON.parse(item.introduce);
            item.numbers = JSON.parse(item.numbers);
            item.title = JSON.parse(item.title);
          }
        });
        this.aboutPage = response.data.rows;
        console.log(this.aboutPage, "关于我们");
        localStorage.setItem("aboutUs", JSON.stringify(this.aboutPage));
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
    //获取页面内容-荣誉
    async getSwiper() {
      const cache = localStorage.getItem("Swipers");
      if (cache) {
        this.aboutSwiper = JSON.parse(cache);
      }
      try {
        const response = await axios.get(
          `${websiteUrl}/mes-official-website-manage/aboutHonor/list`
        );
        const data = response.data.rows;
        data.forEach((item) => {
          if (typeof item.content === "string") {
            item.content = JSON.parse(item.content);
            if (Array.isArray(item.content)) {
              item.content = item.content.map((contentItem) => {
                // 情况1：直接是图片路径（字符串）
                if (typeof contentItem === "string") {
                  return fileUrl + contentItem; // 直接拼接并返回新值
                }
                // 情况2：对象，且包含 image 属性
                else if (contentItem.image) {
                  contentItem.image = fileUrl + contentItem.image;
                  return contentItem; // 返回修改后的对象
                }
                // 其他情况（如 null、undefined、非图片数据）
                return contentItem;
              });
            }
            item.title = JSON.parse(item.title);
          }
        });
        this.aboutSwiper = response.data.rows;
        console.log(this.aboutSwiper, "荣誉");
        localStorage.setItem("Swipers", JSON.stringify(this.aboutSwiper));
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
  },
};
</script>

<style scoped>
/* 基础样式 */
#AboutUs {
  font-family: "Microsoft YaHei", Arial, sans-serif;
  color: #333;
  line-height: 1.6;
}

/* 横幅样式 */
.company-banner {
  margin-top: 62px;
  height: 400px;
  background: linear-gradient(rgba(0, 57, 135, 0.7), rgba(0, 57, 135, 0.7)),
  url("../assets/img/banner1.png") center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
}

.banner-content h1 {
  font-size: 48px;
  margin-bottom: 15px;
}

.banner-content p {
  font-size: 20px;
  letter-spacing: 2px;
}

/* 内容容器 */
.about-container {
  max-width: 1200px;
  margin: 50px auto;
  padding: 0 20px;
}

/* 通用区块样式 */
.about-section {
  margin-bottom: 60px;
  padding: 30px 0;
}

.section-title {
  text-align: center;
  font-size: 32px;
  color: #003987;
  margin-bottom: 40px;
  position: relative;
}

.section-title::after {
  content: "";
  display: block;
  width: 80px;
  height: 3px;
  background: #003987;
  margin: 15px auto;
}

/* 公司概况 */
.company-image {
  max-width: 100%;
  height: auto;
  margin-top: 20px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

/* 发展历程 */
.timeline {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
  padding-left: 50px;
}

.timeline::before {
  content: "";
  position: absolute;
  left: 50px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #003987;
}

.timeline-item {
  position: relative;
  margin-bottom: 40px;
}

.timeline-year {
  position: absolute;
  left: -100px;
  top: 0;
  width: 80px;
  text-align: right;
  font-weight: bold;
  color: #003987;
}

.timeline-dot {
  position: absolute;
  /* left: 42px; */
  top: 5px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #003987;
  border: 3px solid white;
  box-shadow: 0 0 0 2px #003987;
}

.timeline-content {
  padding: 20px;
  background: #f9f9f9;
  border-radius: 6px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
}

.timeline-content h3 {
  margin-top: 0;
  color: #003987;
}

/* 企业文化 */
.culture-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 30px;
}

.culture-item {
  text-align: center;
  padding: 30px 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s;
}

.culture-item:hover {
  transform: translateY(-5px);
}

.culture-icon {
  font-size: 40px;
  color: #003987;
  margin-bottom: 15px;
}

.culture-item h3 {
  margin: 15px 0;
  color: #003987;
}

/* 团队展示 */
.team-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.team-member {
  display: flex;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.member-avatar {
  width: 120px;
  height: 120px;
  object-fit: cover;
}

.member-info {
  padding: 20px;
  flex: 1;
}

.member-info h3 {
  margin-top: 0;
  color: #003987;
}

.position {
  color: #666;
  font-style: italic;
  margin: 5px 0;
}

.bio {
  font-size: 14px;
  color: #666;
}
.about-section {
  box-shadow: 0 5px 20px rgba(0, 57, 135, 0.08);
  border-radius: 8px;
  padding: 30px;
  margin-bottom: 40px;
  background: white; /* 确保背景色不透明 */
  transition: box-shadow 0.3s ease;
}

/* 悬停时阴影加深（可选） */
.about-section:hover {
  box-shadow: 0 8px 25px rgba(0, 57, 135, 0.12);
}

/* 2. 移除内部小元素的阴影（避免重复） */
.timeline-content,
.culture-item,
.team-member,
.company-image {
  box-shadow: none !important; /* 强制覆盖原有阴影 */
}

/* 3. 调整时间轴连接线位置（因新增父级阴影需微调） */
.timeline::before {
  left: 60px; /* 原50px → 60px */
}

.timeline-dot {
  left: -25px; /* 原42px → 52px */
}

.timeline-year {
  left: -110px; /* 原-100px → -110px */
}
.carousel-section {
  margin: 60px 0;
}

.custom-carousel {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 57, 135, 0.1);
}

.carousel-card {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.carousel-image {
  width: 100%;
  height: 70%;
  object-fit: cover;
}

.carousel-content {
  padding: 20px;
  background: white;
  height: 30%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.carousel-content h3 {
  color: #003987;
  margin: 0 0 10px 0;
  font-size: 20px;
}

.carousel-content p {
  color: #666;
  margin: 0;
  font-size: 14px;
}

/* 双层轮播容器 */
.double-carousel {
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-top: 40px;
}
/* 双层轮播副标题样式 - 方案四 */
/* .double-carousel h2 {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  text-align: center;
  font-size: 18px;
  color: #444;
  margin: 12px 0 28px;
  font-weight: 400;
  text-transform: uppercase; /* 英文大写
  letter-spacing: 2px;
} */
/* 双层轮播副标题样式 - 方案二 */
.double-carousel h2 {
  text-align: center;
  font-size: 20px;
  color: #555; /* 使用深灰色更柔和 */
  margin: 10px 0 30px;
  font-weight: 400;
  position: relative;
  padding-bottom: 8px;
}

.double-carousel h2::after {
  content: "";
  display: block;
  width: 40px;
  height: 1px;
  background: #ddd; /* 浅色细线 */
  margin: 8px auto 0;
}
/* 上层著作权轮播 */
.upper-carousel {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 3px 10px rgba(0, 57, 135, 0.1);
}

.certificate-carousel {
  width: 100%;
}

.certificate-item {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background: #f8f9fa;
}

.certificate-image {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
  border: 1px solid #eee;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 下层图文轮播 */
.lower-carousel {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 57, 135, 0.1);
}

.custom-carousel {
  width: 100%;
}

.carousel-card {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.carousel-image {
  width: 100%;
  height: 70%;
  object-fit: cover;
}

.carousel-content {
  padding: 20px;
  background: white;
  height: 30%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* 共用箭头样式 */
:deep(.el-carousel__arrow) {
  background-color: rgba(0, 57, 135, 0.5);
  color: white;
  width: 40px;
  height: 40px;
  font-size: 20px;
}

:deep(.el-carousel__arrow:hover) {
  background-color: rgba(0, 57, 135, 0.8);
}

:deep(.el-carousel__indicators) {
  bottom: 15px;
}

:deep(.el-carousel__button) {
  background-color: rgba(255, 255, 255, 0.5);
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

:deep(.el-carousel__indicator.is-active button) {
  background-color: #003987;
}

/* ==================== 响应式调整 ==================== */
@media (max-width: 768px) {
  .about-section {
    padding: 20px;
    box-shadow: 0 3px 10px rgba(0, 57, 135, 0.05);
  }

  .timeline::before {
    left: 40px; /* 调整移动端时间轴位置 */
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .company-banner {
    height: 300px;
  }

  .banner-content h1 {
    font-size: 36px;
  }

  .timeline {
    padding-left: 30px;
  }

  .timeline::before {
    left: 30px;
  }

  .timeline-year {
    left: -80px;
    width: 60px;
  }

  .timeline-dot {
    left: 22px;
  }

  .team-member {
    flex-direction: column;
  }

  .member-avatar {
    width: 100%;
    height: 200px;
  }

  /* ========== 修复轮播图手机端显示问题 ========== */

  /* 修复第一个轮播图（证书/专利）- 解决下拉框问题 */
  .upper-carousel {
    margin-bottom: 10px;
  }

  .certificate-carousel {
    height: 260px !important;
  }

  .certificate-carousel .el-carousel__container {
    height: 260px !important;
  }

  .certificate-item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background: #f8f9fa;
    padding: 10px;
  }

  .certificate-image {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
    border: 1px solid #eee;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  /* 修复第二个轮播图（图文轮播）- 解决图片被裁剪问题 */
  .lower-carousel {
    margin-top: 10px;
  }

  .custom-carousel {
    height: 320px !important;
  }

  .custom-carousel .el-carousel__container {
    height: 320px !important;
  }

  .carousel-card {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
  }

  /* 图片区域 - 使用 object-fit: contain 保持完整显示 */
  .carousel-image {
    width: 100%;
    height: 180px;
    object-fit: contain;
    background-color: #f8f9fa;
    padding: 10px;
  }

  /* 内容区域 */
  .carousel-content {
    padding: 12px 15px;
    background: white;
    height: auto;
    min-height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow-y: auto;
  }

  .carousel-content h3 {
    color: #003987;
    margin: 0 0 8px 0;
    font-size: 16px;
    font-weight: 600;
  }

  .carousel-content p {
    color: #666;
    margin: 0;
    font-size: 12px;
    line-height: 1.5;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  /* 轮播箭头调整 */
  :deep(.el-carousel__arrow) {
    width: 30px;
    height: 30px;
    font-size: 14px;
  }

  /* 轮播指示器调整 */
  :deep(.el-carousel__indicators) {
    bottom: 5px;
  }

  :deep(.el-carousel__button) {
    width: 8px;
    height: 8px;
  }

  /* 确保卡片类型轮播不溢出 */
  :deep(.el-carousel__item--card) {
    width: 85% !important;
  }

  :deep(.el-carousel__item--card.is-active) {
    transform: scale(1) !important;
  }
}

/* 小屏手机额外优化 (小于480px) */
@media (max-width: 480px) {
  /* 第一个轮播图 */
  .certificate-carousel {
    height: 220px !important;
  }

  .certificate-carousel .el-carousel__container {
    height: 220px !important;
  }

  /* 第二个轮播图 */
  .custom-carousel {
    height: 280px !important;
  }

  .custom-carousel .el-carousel__container {
    height: 280px !important;
  }

  .carousel-image {
    height: 150px;
  }

  .carousel-content {
    padding: 10px 12px;
    min-height: 100px;
  }

  .carousel-content h3 {
    font-size: 14px;
    margin-bottom: 5px;
  }

  .carousel-content p {
    font-size: 11px;
    -webkit-line-clamp: 2;
  }
}
</style>

<!-- 全局富文本样式（穿透scoped限制） -->
<style>
.rich-text-content {
  font-family: "Helvetica Neue", Arial, sans-serif;
  line-height: 1.8;
  /* color: #34495e; */
  color: #000;
  font-size: 16px;
}

/* 段落优化 */
.rich-text-content p {
  margin: 1em 0;
  text-indent: 0; /* 取消首行缩进 */
}

/* 图片高级处理 */
.rich-text-content img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 25px auto;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.rich-text-content img:hover {
  transform: scale(1.02);
}

/* 响应式表格（备用） */
.rich-text-content table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}
</style>

<style src="../assets/css/vue-quill.bubble.css"></style>



// WEBPACK FOOTER //
// src/view/CompanyIntroduction.vue